import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ConsultarPreguntasService } from 'src/app/administrador-preguntas/consultar-preguntas.service';
import { Globals } from 'src/app/globals';
import { saveAs } from "file-saver";
import * as moment from 'moment';
import 'moment-timezone'
import Swal from "sweetalert2";
import { Location } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { parse } from '@fortawesome/fontawesome-svg-core';
import { ConflictosService } from 'src/app/administrador-conflictos/servicios/conflictos.service';
@Component({
  selector: 'app-resumen-encuesta',
  templateUrl: './resumen-encuesta.component.html',
  styleUrls: ['./resumen-encuesta.component.css']
})
export class ResumenEncuestaComponent implements OnInit {
  dataSource = new MatTableDataSource([]);

  loading = true;

  anio_actual = new Date().getFullYear();
  texto_cabecera = '';
  texto_subtitulo = '';

  displayedColumns: string[] = ["nombre", "correo", "posicion"];
  conflictos_ok = null;

  historicoEdicion=null;
  texto_boton_finalizar: string = '';
  respuestaEncontrada;

  existeInformacion=true;
  historicoRespuesta;
  verHistorialEdicion=false;
  verHistorialEdicionAll=false;

  encabezadoHistorial=[]
  datosHistorial=[]
  encabezadosDeHistorial=[];
  datosDeHistorial=[];
  listaActivos=[]

  constructor(public globals:Globals,public ConsultarPreguntas:ConsultarPreguntasService,private location: Location,private consultarPreguntas:ConsultarPreguntasService, private conflictosService: ConflictosService) {
    if ( this.globals.lenguaje == "en" || this.globals.lenguaje == "ingles" ) {
      this.globals.lenguaje = "en";
    } else {
      this.globals.lenguaje = "es";
    }
   }

  ngOnInit() {
    if(this.globals.tipoConsulta=="TodasRespuestas"){
      this.consultarHistorial()

      if(this.globals.lenguaje == 'es'){
        this.texto_cabecera = ' Encuesta de Conflictos de Interés';
        this.texto_subtitulo = 'A continuación podrás ver las respuestas de '+this.globals.funcionarioSeleccionado.nombre_completo;
        this.texto_boton_finalizar = 'Finalizar Encuesta';
      }else{
        this.texto_cabecera = 'The Survey of Conflicts of Interest';
        this.texto_subtitulo = 'Below you can see your answers of  '+this.globals.funcionarioSeleccionado.nombre_completo;
        this.texto_boton_finalizar = 'Exit Survey';
      }
    }

    if(this.globals.tipoConsulta=="RespuestaIndividual"){
      this.consultarRespuesta();

    }

  }

  consultarHistorial() {


    this.conflictos_ok = this.globals.historialRespuestasSeleccionado;



    //console.log(this.conflictos_ok)
      let con = 0;

      this.conflictos_ok.forEach(el => {
        if(con>0){
          let response=true;
          let nombre_pregunta = '';
          let desc_pregunta   = '';
          let aclaracion_preg = '';
          let tipo_pregunta   = null;


          tipo_pregunta   = el.tipo_desc.TipoPregunta;
          //////conole.log("TIPO PREGUNTA",el)

          //Datos de Pregunta
          if(this.globals.lenguaje == 'es'){
            nombre_pregunta = el.tipo_desc.nombre;
            desc_pregunta   = el.tipo_desc.tipo_conflicto_espanol;
            aclaracion_preg = el.tipo_desc.DescripcionPregunta;
          }else{
            nombre_pregunta = el.tipo_desc.ingles;
            desc_pregunta   = el.tipo_desc.tipo_conflicto_ingles;
            aclaracion_preg = el.tipo_desc.InglesDescripcionPregunta;
          }

          // Texto1ES
          // Texto1EN

          el.tipo_conflicto = desc_pregunta;
          el.desc_pregunta = nombre_pregunta;
          el.aclaracion_preg = aclaracion_preg;

          if(tipo_pregunta == 4){

            let parts_desc_ack = "";

            //Descripcion Manifiestos
            if(this.globals.lenguaje == 'es'){
              if(el.tipo_desc.Texto1ES != " " && el.tipo_desc.Texto2ES != " " && el.tipo_desc.Texto3ES != " " && el.tipo_desc.Texto4ES != " " && el.tipo_desc.Texto5ES != " "){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1ES+"</li><li>"+el.tipo_desc.Texto2ES+"</li><li>"+el.tipo_desc.Texto3ES+"</li><li>"+el.tipo_desc.Texto4ES+"</li><li>"+el.tipo_desc.Texto5ES+"</li></ul>";
              }else if(el.tipo_desc.Texto1ES != " "){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1ES+"</li></ul>";
              }
            }else{
              if(el.tipo_desc.Texto1EN != " " && el.tipo_desc.Texto2EN != " " && el.tipo_desc.Texto3EN != " " && el.tipo_desc.Texto4EN != " " && el.tipo_desc.Texto5EN != " "){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1EN+"</li><li>"+el.tipo_desc.Texto2EN+"</li><li>"+el.tipo_desc.Texto3EN+"</li><li>"+el.tipo_desc.Texto4EN+"</li><li>"+el.tipo_desc.Texto5EN+"</li></ul>";
              }else if(el.tipo_desc.Texto1EN != " " ){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1EN+"</li></ul>";
              }
            }

            let descripcion_ack = parts_desc_ack;
            el.descripcion_ack = descripcion_ack;
            //////conole.log("CLAUSULA",el.descripcion_ack)
          }


          // //////conole.log('Pregunta:',nombre_pregunta,'Descripcion:',desc_pregunta);
          let json_data = [];
          let headers_data = [];
          let headers = [];

          if(tipo_pregunta == 3){
            // if(el.idtbl_conflicto == 12){ //Comentado para descartar tipo 12
              // el.respuesta = [el.respuesta[1]];
            // }else{
              el.respuesta = [el.respuesta[0]];
            // }
          }else if(tipo_pregunta == 4){
            el.respuesta = [el.respuesta[0]];
          }


          el.respuesta.forEach(rs => {

            let arr_header = [];
            let arr_valor = [];

            //Si el tipo es dilema etico o manifiesto, tome la primera opcion (Ultima respuesta diligenciada)
            if(tipo_pregunta == 3 ){
                if(rs){
                  rs = [rs[1]];
                }

            }else if(tipo_pregunta == 4 ){
              if(rs){
                rs = [rs];
              }

            }



            // //////conole.log(tipo_pregunta,'RS Modificado:',rs)

            let anio = '';
            let fechaModificacion=''
            let fechaCreacion=''


            if(rs){



              rs.forEach(rsdet => {

               if(rsdet){
               fechaModificacion=rsdet.fecha_modificacion_registro
               fechaCreacion=rsdet.fecha_registro

              }

                //Skip Respuesta tipo Vigencia del Conflicto
                //if(rsdet.id_tipo_respuesta == 32){
                  //return;
                //}

                if(rsdet && rsdet.idtbl_respuestas_adicionales != '0'){

                  if(tipo_pregunta == 4){
                    if(this.globals.lenguaje == 'es'){
                      rsdet.nombre = 'Acepta Manifestación de Cumplimiento';
                    }else{
                      rsdet.nombre = 'Accept Terms and Conditions'
                    }


                    rsdet.fecha_registro=moment(rsdet.fecha_registro).add(5,'hours').tz("America/Bogota").format('YYYY/MM/DD hh:mm:ss')
                  }

                  let header = '';
                  if(this.globals.lenguaje == 'es'){
                    header = rsdet.nombre;
                  }else{
                    header = rsdet.ingles;
                  }

                  let valor = rsdet.valor;


                  if(rsdet.id_tipo_respuesta == "35" || rsdet.id_tipo_respuesta == "36"){
                    if(valor){
                      valor = valor.split('T')[0];

                    }
                  }

                  anio = rsdet.annio;

                  arr_header.push(header);
                  arr_valor.push(valor);

                  // //////conole.log('Header:',header,'Valor:',valor);




                }
              });
              this.existeInformacion=true;




              if(fechaModificacion != '' && tipo_pregunta == 2 && fechaModificacion!='0' && fechaModificacion){


                //////conole.log("TI 2",el)
                let label_fechaMod = '';

                if(this.globals.lenguaje == 'es'){
                  label_fechaMod = 'Fecha Edición';
                }else{
                  label_fechaMod = 'Edit Date'
                }
                arr_header.push(label_fechaMod);


               let modificacion=moment(fechaModificacion).tz("America/Bogota").format('DD/MM/YYYY hh:mm A')
                arr_valor.push(modificacion);

                let annioMod=moment(fechaModificacion).format('YYYY')

                if(annioMod!=this.globals.annioSeleccionado){
                  console.log("No es Año Actual")
                }

                // //////conole.log('Agrega AÑO:',anio)
              }
              else{

                if(fechaCreacion!='' && fechaCreacion!='0' && fechaCreacion){
                let label_fechaMod = '';

                if(this.globals.lenguaje == 'es'){
                  label_fechaMod = 'Fecha Registro';
                }else{
                  label_fechaMod = 'Register Date'
                }
                arr_header.push(label_fechaMod);
                //console.log(fechaCreacion)
               let creacion=moment(fechaCreacion).tz("America/Bogota").format('DD/MM/YYYY hh:mm A')
                arr_valor.push(creacion);
              }
              }



            }


            else{
              //////conole.log('No se ha definido un RS. No hay data registrada')
              this.existeInformacion=false;

              let label_not_data = '';
              if(this.globals.lenguaje == 'es'){
                label_not_data = 'No existen datos';
              }else{
                label_not_data = 'No data';
              }
              rs = [{valor: label_not_data,nombre:' '}];
              arr_header.push(' ');
              arr_valor.push(label_not_data);



            }


            // //////conole.log('Before Set Año:',anio)



            if(anio != '' && tipo_pregunta == 2){
              //////conole.log("TI 2",el)
              let label_anio = '';

              if(this.globals.lenguaje == 'es'){
                label_anio = 'Año';
              }else{
                label_anio = 'Year'
              }
              arr_header.push(label_anio);
              arr_valor.push(anio);
              // //////conole.log('Agrega AÑO:',anio)
            }






            if(rs){
              rs.arr_header = arr_header;
              rs.arr_valor = arr_valor;
            }
            //////conole.log("RESPUESTA RS =>>>>",rs)
            headers = arr_header;

            let json = [];
            for (let index = 0; index < arr_header.length; index++) {
              let head = arr_header[index];
              json[index] = arr_valor[index];
            }
            //json_data.push(json)
            if(headers.length!=0){
              json_data.push(json)
              headers_data.push(headers)
            }
            else{
              let label = [''];

              if(this.globals.lenguaje == 'es'){
                label = ['¿Tiene nuevos conflictos de interés en el presente año?'];
              }else{
                label = ['Do you have new conflicts of interest this year?']
              }

              let valor = ['No'];
              let json_std = {}
              //json_std[label] = valor;
              let valida_push = true;
              for(let i = 0; i < headers_data.length; i++){

                let dato_header = headers_data[i];
                if(dato_header[0] == label[0]){
                  valida_push = false;
                }
              }

              if(valida_push){
                json_data.push(valor);
                headers_data.push(label);
              }

            }
          });


          //Casos donde no hay respuesta
          if(!el.respuesta.length && tipo_pregunta == 2){
            let label = [''];

            if(this.globals.lenguaje == 'es'){
              label = ['¿Tiene nuevos conflictos de interés en el presente año?'];
            }else{
              label = ['Do you have new conflicts of interest this year?']
            }

            let valor = ['No'];
            let json_std = {}
            //json_std[label] = valor;
            let valida_push = true;
            for(let i = 0; i < headers_data.length; i++){
              console.log('segundo dato ', headers_data[i], label);
              let dato_header = headers_data[i];
              if(dato_header[0] == label[0]){
                valida_push = false;
              }
            }

            if(valida_push){
              json_data.push(valor);
              headers_data.push(label);
            }

          }


          el.json_data = json_data;
          el.headers = headers_data;


          let validar_eliminar_no = false;

          if(el.respuesta.length){

          for(let e of el.respuesta){
           if(e){
            if(e.length > 0){
              if(e[0].origen != 0){
                if(e[0].origen == 1){
                  validar_eliminar_no = true;
                }
              }else{
                if(e.length > 1){
                  if(e[1].origen == 1){
                    validar_eliminar_no = true;
                  }
                }
              }
            }
          }
          }
        }

          if(validar_eliminar_no){
            for(let i = 0; i < el.json_data.length; i++){
              let e = el.json_data[i];

              if(e[0] == 'No'){
                el.json_data.splice(i, 1);
                el.headers.splice(i, 1);
              }
            }
          }

        }
        con += 1;
      });

      console.log('Con POSTerior:',this.conflictos_ok)
      this.loading = false;


  }




  consultarRespuesta(){
    this.consultarHistorial()

    this.respuestaEncontrada=this.conflictos_ok.filter(item=>item.idtbl_conflicto==this.globals.preguntaSeleccionada.idtbl_conflicto)

    if(this.respuestaEncontrada){
      console.log("RESPUESTA ENCONTRADA",this.respuestaEncontrada)

      this.existeInformacion=true;

    let respuestaHistorial= this.respuestaEncontrada[0]['historial']

     for(let infoHistorial of respuestaHistorial){

      let lugar=[]
      let array2=[]

    for(let item of infoHistorial){

      let array=[]

      if(item.length>0){
      for(let encabezado of item){

            array.push(encabezado.nombre)

        }


        array.push("Fecha de Edición")
        lugar.push(array)


          let data=[]
          let modificacion;

          for(let conflicto of item){

              data.push(conflicto.valor);
              let fecha=new Date(conflicto.fecha_modificacion)
              modificacion=moment(fecha).add(5,'hours').tz("America/Bogota").format('DD/MM/YYYY hh:mm A')

          }


          data.push(modificacion);

          array2.push(data)

          }


      }

      if(lugar.length){
        this.encabezadosDeHistorial.push(lugar)
      }else{
        if(this.encabezadoHistorial.length<1){
          this.encabezadosDeHistorial.push(lugar)
        }
      }

      if(array2.length){
        this.datosDeHistorial.push(array2.reverse())
      }else{
        if(this.datosDeHistorial.length<1){
          this.datosDeHistorial.push(array2.reverse())
        }
      }


}


      console.log(this.datosDeHistorial)
      console.log(this.encabezadosDeHistorial)

}




  }

  consultarEdicionRespuesta(indice,conflicto){


   this.loading=true;
   this.verHistorialEdicion=false;
   this.verHistorialEdicionAll=false;

   this.loading=false;

      this.encabezadoHistorial=[]
      this.datosHistorial=[]
      let valor=[]

      this.globals.historialEdicionConflictos=conflicto



      for(let encabezado of this.globals.historialEdicionConflictos[1]){
        if(encabezado.nombre!="Vigencia De Conflicto"){
          this.encabezadoHistorial.push(encabezado.nombre)
        }

        }

        this.encabezadoHistorial.push("Fecha de Edición")

        //console.log(this.encabezadoHistorial)


                for(let index = 1; index <  this.globals.historialEdicionConflictos.length; index++){
          let data={}
          for(let encabezado of this.globals.historialEdicionConflictos[index]){

           data[encabezado.nombre] = encabezado.valor;
           data["Fecha de Edición"] = encabezado.fecha_modificacion;
          }

          valor.push(data)


       }


       this.datosHistorial=valor
       //console.log(this.datosHistorial)

        this.loading=false;
        this.verHistorialEdicionAll=true;



  }


  generarPDF(){
        this.loading=true;
        this.ConsultarPreguntas.generarPDF(this.globals.funcionarioSeleccionado.idtbl_funcionario,1,this.globals.lenguaje,this.globals.annioSeleccionado).subscribe(res => {
          let nombreArchivo="Encuesta-"+this.globals.funcionarioSeleccionado.nombre_completo
          saveAs(res, nombreArchivo)
          this.loading=false;
        });
  }

  generarPDFIndividual(){
    this.loading=true;
    this.ConsultarPreguntas.generarPDFIndividual(this.globals.funcionarioSeleccionado.idtbl_funcionario,1,this.globals.lenguaje,this.globals.preguntaSeleccionada.idtbl_conflicto,this.globals.annioSeleccionado,this.listaActivos).subscribe(res => {
      let nombreArchivo="Pregunta-"+this.globals.funcionarioSeleccionado.nombre_completo
      this.listaActivos=[]
      saveAs(res, nombreArchivo)
      this.loading=false;
    });
  }


  regresar(){
    this.location.back();
  }

  historialEdicion(orden,conflicto){
    this.consultarEdicionRespuesta(orden,conflicto);
    this.verHistorialEdicion=true;
  }

  activarHistorial(evento){

    if(evento.target.checked){
      if(this.listaActivos.length>0){
        let bandera="NO ENCONTRADO"
        for(let item of this.listaActivos){
          if(item==evento.target.value){
           bandera="ENCONTRADO"
          }
        }


      if(bandera=="NO ENCONTRADO"){
        this.listaActivos.push(evento.target.value)
      }

    }else{
      this.listaActivos.push(evento.target.value)
    }
  }else{
    if(this.listaActivos.length>0){
      let bandera="NO ENCONTRADO"
      for(let item of this.listaActivos){
        if(item==evento.target.value){
          bandera="ENCONTRADO"
          let index=this.listaActivos.indexOf(item)
          this.listaActivos.splice(index,1)
         }
      }
    }
  }




  }

  verificarLista(i){
    for(let item of this.listaActivos){
      if(item==i){
        return true;
      }
    }
  }


  enviarDocusign(){
    let etiquetaCargando = { es: "Enviando", en: "Sending" };
    Swal.fire(etiquetaCargando[this.globals.lenguaje]);
    Swal.showLoading();
    this.conflictosService.cargarDocusignBtn(this.globals.funcionarioSeleccionado.idtbl_funcionario, 1, this.globals.lenguaje).subscribe(rt=>{
      console.log("RESPUESTA",rt)
      Swal.close();
    })

  }




}
